"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montecchio-precalcino": {
    "05de336b": [{
      "hkey": "c3541954",
      "slug": "montecchio-precalcino",
      "name": "Montecchio Precalcino",
      "primary": true,
      "skipSearch": false
    }],
    "leva": [{
      "hkey": "c3541954",
      "slug": "montecchio-precalcino",
      "name": "Montecchio Precalcino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "729f8cd3": [{
      "hkey": "c3541954",
      "slug": "montecchio-precalcino",
      "name": "Montecchio Precalcino",
      "primary": true,
      "skipSearch": false
    }],
    "preara": [{
      "hkey": "c3541954",
      "slug": "montecchio-precalcino",
      "name": "Montecchio Precalcino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;